import React from "react"
import {BankLogoProps, defaultBankLogoSize} from "./bankLogoUtils"

export function ChoiceFinancialGroupLogo({size = defaultBankLogoSize, fill, className}: BankLogoProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 28 28"
			className={className}
		>
			<path fill={fill} d="M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14Z" />
			<path
				fill="#EE0032"
				d="M14.532 9.097c1.62 2.633 3.824 4.626 6.71 5.975-3.038 1.613-5.247 3.918-6.71 6.928V9.097Z"
			/>
			<path
				fill="#034"
				d="M7.306 12.88C10.124 11.275 12.162 8.992 13.5 6v12.903c-1.49-2.705-3.524-4.681-6.194-6.023Z"
			/>
		</svg>
	)
}
